import { api } from "../../lib/konnective-api-client";
import { Order } from "../../types/api";

const baseURL = 'https://api.konnektive.com/';

export const postOrder = async (order: Order) => {
  try {
    const { data } = await api.post('/order_v1', {...order,});
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const getProduct = async (productId: string) => {
  const { data } = await api.get(`/product/${productId}`);
  return data;
}